export default "__VITE_ASSET__2xtUW_2d__"